<template>
  <div class="cb-body__wrap" v-cb-animate="true" v-if="swapPaymentMethod">
    <div class="cb-body__content">
      <payment-component :payment-method-type = "payment_method_type" @setPaymentType = "setPaymentType($event)"></payment-component>
      <component :field_config="field_config" class="cb-transition__tab cb-payment__mode" :pm="pm" :edit-mode="editMode" @submit="submit()" :is="componentType()" :subscribe-mode='true' referrer='pay_now'>
      </component>
      <div v-if="canShowSaveCheckBox" class="cb-check cb-transition__fade">
        <template v-if="canAdd">
          <div class="cb-check__group">
            <div class="cb-check__left">
              <input type="checkbox" ref="x" class="cb-check__action cb-check__action--m-top" v-model="retain_card" id="retain_card">
            </div>
            <div class="cb-check__right">
              <label class="cb-check__label" for="retain_card">{{st('use_card_future_payments')}}</label>
              <div class="cb-check__help" v-if="pm && (pm.enabled3ds && pm.gateway !== 'BANK_OF_AMERICA')">
                {{t('3ds.auth.txt', {
                  organisation_name: this.$store.state.config.organisation || this.$store.state.config.site}
                  )}}
              </div>
              <div v-else>
                {{st('use_card_future_payments.info')}}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="cb-check__group">
            <div class="cb-check__left">
              <input type="checkbox" class="cb-check__action cb-check__action--m-top" ref="x" v-model="replace_primary_pm" id="replace_primary_pm">
            </div>
            <div class="cb-check__right">
              <label for="replace_primary_pm" class="cb-check__label">{{st('replace_primary_source')}}</label>
              <div class="cb-check__help">
                {{st('replace_primary_source.info')}}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="cb-body__footer cb-body__footer--text" v-if="!show_card_review_btn">
      <cb-notes v-if="canShowMandateText" slot="notes" :custom-class="'cb-section'" :type="'warning'" :message="eMandateTxt"></cb-notes>
      <checkout-subscribe :show-loader="showLoader" @submit="submit()" :txt-key="'button.txt'" :total="amountToBePaid" :hide-button-override="!this.showTopLevelPaymentButton()">
      </checkout-subscribe>
    </div>
    <div class="cb-payment__footer" v-if="show_card_review_btn">
      <cb-button :custom-class="'primary'" @next="validateForm()">
        {{t('payment_method.bank_account.btn.proceed_to_review')}} <i class="icon-long-arrow-right"></i>
      </cb-button>
    </div>
  <cb-notes v-if="pm && pm.enabled3ds" slot="notes" class="cb-notebar--footer" :type="'muted'" :message="t('threeds.warning')"> </cb-notes>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
import PaymentMixin from "@/mixins/payment-mixin"
import CurrencyFilter from "@/filters/currency"
import PaymentComponent from "@/components/modules/hosted-pages/PaymentComponent"
import CBNotification from "@/models/cb-notification"
import LazyLoadPaymentComponents from '@/components/modules/hosted-pages/LazyLoadPaymentComponents'
import Notes from "@/components/collections/elements/Notes"
import { paymentStep } from '@/utils/payment-helper';
const { SECOND_STEP } = paymentStep;

export default {
  mounted() {
    this.payment_method_type = this.pm_list[0] && this.pm_list[0].type;
    if(!this.payment_method_type) {
      this.$store.dispatch('set_current_notification', new CBNotification('error', {message: "Cannot proceed with a valid gateway account"}));
    }
    if(this.canAdd) {
      this.retain_card = true;
    }
  },
  computed: {
    ...mapGetters([
      "amountToBePaid",
      "currency_code",
      "pm_authorized",
      "paypal",
      "canAdd",
      "show_mandate_screen",
      "mandate_step"
    ]),
    isDirectDebit() {
      if (this.payment_method_type == "direct_debit" &&
          this.pm &&
          this.pm.gateway_name == "CYBERSOURCE" &&
          this.pm.configuration.scheme == "ACH") {
        return true;
      }
      return false;
    },
    canShowSaveCheckBox() {
      return ['bancontact', 'ideal', 'sofort'].includes(this.payment_method_type) || this.pm_authorized || this.isDirectDebit ||
      (this.payment_method_type == 'card' && !this.show_mandate_screen) || (this.payment_method_type == 'card' && this.show_mandate_screen && this.mandate_step == SECOND_STEP)
    },
    canShowMandateText() {
      return  this.$store.getters.pm_by_mandate_enabled && (this.replace_primary_pm || this.retain_card) && this.isSingleleSubInvoiceSelected();
    },
    eMandateTxt() {
      return 'For cards issued in India, an e-mandate will be set up to automate recurring payments for this subscription. The mandate specifies broad terms so variations in the recurring charge (amount or frequency) do not require your manual confirmation. You will only be charged according to the plan you subscribe to.'
    }
  },
  props: ['editMode'],
  mixins: [PaymentMixin],
  methods: {
    // next() {
    //   this.$emit('next');
    // },
    submit() {
      window.logger.i({retain_card: this.retain_card});
      this.addAndSubmitForCollection();
    },
    _displayErrorMessage() {
      let error = this.current_error_source;
      if(!this.current_error_source) {
        return;
      }
      if(error.isParamException && error.isParamException()){
        this.$store.dispatch('set_error', {name: error.paramName, fname: this.fname,
          error: error.paramMessage
        });
      }
    },
    setPaymentType(type) {
      this.$store.dispatch('set_pm_consent', true);
      this.payment_method_type = type;
      this.$emit('setPaymentType',type);
    }
  },
  components: {
    'card-section': LazyLoadPaymentComponents.PortalCardSection,
    'paypal-section': LazyLoadPaymentComponents.PaypalSection,
    'direct-debit-section': LazyLoadPaymentComponents.DirectDebitSection,
    'amazon-payment-section':  LazyLoadPaymentComponents.AmazonPaymentSection,
    'apple-pay-section': LazyLoadPaymentComponents.ApplePaySection,
    'payment-component' : PaymentComponent,
    'cb-notes': Notes,
    'ideal-section': LazyLoadPaymentComponents.iDealSection,
    'sofort-section': LazyLoadPaymentComponents.SofortSection,
    'bancontact-section': LazyLoadPaymentComponents.BancontactSection,
    'google-pay-section': LazyLoadPaymentComponents.GooglePaySection,
    'giropay-section': LazyLoadPaymentComponents.GiropaySection,
    'dotpay-section': LazyLoadPaymentComponents.DotpaySection,
    'netbanking-section': LazyLoadPaymentComponents.NetbankingSection,
    'upi-section': LazyLoadPaymentComponents.UpiSection,
    
  },
  data() {
    return {
      showLoader: false,
      payment_method_type: undefined,
      retain_card: false,
      replace_primary_pm: false,
      showLoader: false,
      showOptions: true,
      swapPaymentMethod : true,
    }
  }
}
</script>
<style lang="stylus" scoped>
  .cb-check__action--m-top{
    margin-top: 2px;
  }
</style>
